import styled from 'styled-components'

import CardTitle from '../../../../common/styles/CardTitle'
import useRatingDistribution from '../hooks/useRatingDistribution'
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip} from 'chart.js'
import {Bar} from 'react-chartjs-2'
import {useDarkMode} from '../../../../common/hooks/DarkModeContext'
import React from 'react'
import getBarColors from '../utils/getBarColors'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip)

const BookStatisticsRatingCard = () => {
	const [data, isLoading] = useRatingDistribution()
	const {isDark} = useDarkMode()
	const chartRef = React.useRef<any>(null)

	const chartValues = data ? [data.star1, data.star2, data.star3, data.star4, data.star5] : [0, 0, 0, 0, 0]

	const focusOnGreatest = React.useCallback(() => {
		const chart = chartRef.current
		if (!chart || chartValues.length === 0) return
		const maxIndex = chartValues.lastIndexOf(Math.max(...chartValues))
		if (chartValues[maxIndex] !== 0) {
			chart.tooltip?.setActiveElements([{datasetIndex: 0, index: maxIndex}], {x: 0, y: 0})
			chart.update()
		}
	}, [chartValues])

	React.useEffect(() => {
		focusOnGreatest()
	}, [data])

	return (
		<Container>

				<CardTitle icon={null} mb={0} title={'별점 분포'} url={''} textSize={5}/>

				<AverageText>
					{data ? <>평균 별점 <strong>{data.averageRating.toFixed(1)}</strong>점</> : '\u00A0'}
				</AverageText>

				<ChartContainer onMouseLeave={() => setTimeout(focusOnGreatest, 50)}>
					<Bar
						ref={chartRef}
						data={{
							labels: ['1점', '2점', '3점', '4점', '5점'],
							datasets: [{
								data: chartValues,
								backgroundColor: getBarColors(chartValues),
								borderRadius: 4,
							}],
						}}
						options={{
							animation: isLoading ? false : undefined,
							onHover: (_event, activeElements) => {
								if (activeElements.length === 0) focusOnGreatest()
							},
							plugins: {
								legend: {display: false},
								tooltip: {enabled: !isLoading},
							},
							scales: {
								x: {
									ticks: {color: isDark ? '#AAA' : '#666'},
									grid: {display: false},
								},
								y: {
									beginAtZero: true,
									ticks: {
										color: isDark ? '#AAA' : '#666',
										stepSize: 1,
									},
									grid: {color: isDark ? '#FFFFFF1A' : '#0000001A'},
								},
							},
							maintainAspectRatio: false,
						}}
					/>
				</ChartContainer>

		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
`

const ChartContainer = styled.div`
	height: 250px;
`


const AverageText = styled.div`
	text-align: center;
	margin-bottom: 15px;
	color: var(--sub-text-color);
	font-size: 16px;
`

export default BookStatisticsRatingCard
